(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('modello', {
            parent: 'entity',
            url: '/modello?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ordiniApp.modello.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/modello/modellos.html',
                    controller: 'ModelloController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('modello');
                    $translatePartialLoader.addPart('tipoModello');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('modello-detail', {
            parent: 'entity',
            url: '/modello/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ordiniApp.modello.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/modello/modello-detail.html',
                    controller: 'ModelloDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('modello');
                    $translatePartialLoader.addPart('tipoModello');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Modello', function($stateParams, Modello) {
                    return Modello.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'modello',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('modello-detail.edit', {
            parent: 'modello-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/modello/modello-dialog.html',
                    controller: 'ModelloDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Modello', function(Modello) {
                            return Modello.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('modello.new', {
            parent: 'modello',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/modello/modello-dialog.html',
                    controller: 'ModelloDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                descrizione: null,
                                tipo: null,
                                file: null,
                                fileContentType: null,
                                utenteCreazione: null,
                                dataCreazione: null,
                                utenteAggiornamento: null,
                                dataAggiornamento: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('modello', null, { reload: 'modello' });
                }, function() {
                    $state.go('modello');
                });
            }]
        })
        .state('modello.edit', {
            parent: 'modello',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/modello/modello-dialog.html',
                    controller: 'ModelloDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Modello', function(Modello) {
                            return Modello.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('modello', null, { reload: 'modello' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('modello.delete', {
            parent: 'modello',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/modello/modello-delete-dialog.html',
                    controller: 'ModelloDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Modello', function(Modello) {
                            return Modello.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('modello', null, { reload: 'modello' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
